<plotly-plot [data]="data" [layout]="layout" [config]="config"> </plotly-plot>
